import { ReactElement } from 'react'
import { MenuItem } from '@mui/material'
import { useUIStore } from '@stores'

interface Props {
  // Closes the navbar's own dropdown -- left open behind the dialog, it keeps
  // capturing keystrokes (its type-ahead menu-item search) instead of letting
  // them reach the form's text fields.
  onCloseNavbarMenu: () => void
}

/**
 * Only the trigger: the dialog itself is mounted in the editor tree
 * (EditProjectDialog) rather than here, because the navbar's dropdown
 * unmounts its children on close -- rendering the dialog inside this
 * component closed it the instant the menu did.
 */
const EditProject = ({ onCloseNavbarMenu }: Props): ReactElement => {
  const setIsEditProjectDialogOpen = useUIStore(state => state.setIsEditProjectDialogOpen)

  return (
    <MenuItem
      onClick={() => {
        onCloseNavbarMenu()
        setIsEditProjectDialogOpen(true)
      }}
      data-cy="navbar-menu-edit-project"
    >
      Bearbeiten
    </MenuItem>
  )
}

export default EditProject
